import { SimpleGrid } from "@chakra-ui/layout";
import { Flex, Button, Spacer } from "@chakra-ui/react";
import DateRangePicker from "ui/components/Input/DateRangePicker";
import { FiRefreshCw } from "react-icons/fi";
import CardSubcontas from "./components/CardSubcontas";
import CardComissoes from "./components/CardComissoes";
import CardTempoContrato from "./components/CardTempoContrato";
import CardQuantidade from "./components/CardQuantidade";

function DashboardTab() {
  return (
    <>
      <Flex gap="8px" pt="2px" mb={4}>
        <Spacer />
        <Flex w="350px" flexDir="row" gap="24px">
          <Button
            bg="white"
            w={"150px"}
            fontSize="14px"
            variant="outline"
            fontWeight="normal"
            // onClick={() => reload()}
            leftIcon={<FiRefreshCw fontSize="16px" />}
          >
            atualizar
          </Button>
          <DateRangePicker
            onChange={(dataInicio, dataFim) => {
              // update("dataInicio", dataInicio);
              // update("dataFim", dataFim);
            }}
            value={{
              dataInicio: "2022-01-01", //query.dataInicio,
              dataFim: "2022-01-01", //query.dataFim,
            }}
          />
        </Flex>
      </Flex>
      <SimpleGrid columns={{ sm: 2, md: 2, lg: 4 }} gap="32px" mb="32px">
        <CardSubcontas />
        <CardComissoes />
        <CardTempoContrato />
        <CardQuantidade />
      </SimpleGrid>
    </>
  );
}

export default DashboardTab;
